type NumericKey<T> = {
  [K in keyof T]-?: T[K] extends number | null | undefined ? K : never;
}[keyof T];

export function sum(nums: number[]): number;
export function sum<T extends object>(
  values: T[],
  key: NumericKey<T>
): number;
export function sum<T extends object>(
  values: number[] | T[],
  key?: NumericKey<T>
): number {
  if (key === undefined) {
    return (values as number[]).reduce((a, b) => a + b, 0);
  }

  return (values as T[]).reduce(
    (acc, value) => acc + ((value[key] as number | null | undefined) ?? 0),
    0
  );
}

export function combine<T>(
  values: T[],
  identity: T,
  add: (a: T, b: T) => T
): T {
  return values.reduce((acc, v) => add(acc, v), identity);
}
